/** @file The editor's message catalogs: @pose2d/i18n catalogs merged with the generated i18n parts. */
import { mergeCatalogParts } from '@pose2d/i18n/mergeCatalogParts';
import { CATALOG_PARTS } from '../../catalog.gen';

/** `{ en, th, … }` handed to createT; built once at module load. */
export const catalogs = mergeCatalogParts(CATALOG_PARTS);
